const PRODUCTION_API_URL = 'https://www.klenmarket.ru';

export function getApiBaseUrl(): string {
    if (
        window.location.hostname === 'localhost' ||
        window.location.hostname === 'www.klenmarket.ru'
    ) {
        return PRODUCTION_API_URL;
    }

    return window.location.origin;
}
